export default {
  logs: 'Логи',
}
